/*ReactJS*/
import React from 'react';

/*Material UI Components*/
import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*Styles*/
import useStyles from '../../styles';

/*Table Components*/
import InventoryReportTable from './Components/InventoryReportTable';

export default function InventoryReport(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <Box>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            Inventory Report
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Position</span>
            <Typography color="primary">Inventory Report</Typography>
          </Breadcrumbs>
        </Box>
        <Box mt={2}>
          <InventoryReportTable params={props} />
        </Box>
      </div>
    </React.Fragment>
  );
}
